import React from "react";
import { PageList } from "../components/pageList";
import { useTableSchema } from "../hooks/useTableSchema";
import { useFormSchema } from "../hooks/useFormSchema";

const Payback = ({ title = "Payback" }) => {
  const [getTableSchema] = useTableSchema();
  const [getFormSchema] = useFormSchema();

  return (
    <PageList
      title={title}
      apiEntity={"payroll"}
      preQuery={{ type: "PAYBACK" }}
      tableSchema={getTableSchema("payroll")}
      formSchema={getFormSchema("payback")}
      showImport={false}
      initSort={{ by: "code", order: "desc" }}
      searchByTextField={false}
      // stats={{
      //   component: ProjecPageStats,
      //   props: {
      //     mb: 35,

      //   },
      // }}
    />
  );
};

export default Payback;
